import {CSSProperties} from '../../../styleSheet';
import {BaseVisibilityProps} from '../types';

export const buildVisibilityStyle = ({
  visibility,
  hidden,
}: BaseVisibilityProps = {}): CSSProperties => {
  return {
    ...(visibility ? {visibility} : undefined),
    ...(hidden ? {visibility: 'hidden'} : undefined),
  };
};
